import { AuthConfig } from "angular-oauth2-oidc";
import { environment } from "src/environments/environment";

export const authConfig: AuthConfig = {
  // Url of the Identity Provider
  // loginUrl: 'http://oauth-server.x2iq.com/uaa/oauth/authorize',
  loginUrl: environment.oauthProviderUrl,
  userinfoEndpoint: environment.userInfo,
  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin + "/",

  // redirectUri:
  //   "https://s3.frontend.rule10b51.staging.eu-central-1.master.2iq.cloud/",
  // The SPA's id. The SPA is registerd with this id at the auth-server
  clientId: environment.clientId,

  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. The 4th is a usecase-specific one
  scope: "openid",
  oidc: false,
  showDebugInformation: true,
  requireHttps: false,
};
